// extracted by mini-css-extract-plugin
export default {"layoutContainer":"MainLayout_layoutContainer__zIpz3","mainContent":"MainLayout_mainContent__wMqHY","contentArea":"MainLayout_contentArea__zBVUj"};